<template>
  <v-dialog :value="value" width="665px" @input="$emit('input', $event)" @click:outside="closeDialog">
    <v-card>
      <v-card-title>
        <span class="table-card-title">Falha na importação</span>
      </v-card-title>
      <v-card-text class="px-0">
        <v-row no-gutters>
          <v-col cols="12" class="px-3">
            <span class="subtitulo">Alterações realizadas:</span>
          </v-col>
          <v-col cols="12" class="px-3 py-0">
            <v-alert dense text type="error">
              <span class="texto-erro">
                Erro de criação em {{ failureResponse.totalFailures }} produtos. <a class="text-alert" @click="exportCsv">Clique para exportar a lista.</a>
              </span>
            </v-alert>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="pa-0">
            <v-data-table :items="failureResponse.failedLines" :headers="headers" disable-filtering disable-pagination disable-sort hide-default-footer>
              <template v-slot:item.reason="{ item }">
                {{ parseReason(item.reason) }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <mf-action-buttons
          :primary-button="{
            text: 'Fechar',
            action: closeDialog,
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { getCsvFromBucket } from '@/config/helpers.js'

export default {
  props: {
    value: { type: Boolean },
    totalNumberOfLines: { type: Number },
    failureResponse: { type: Object },
    urlBucket: { type: String },
  },
  computed: {
    headers() {
      return [
        {
          text: 'Linha',
          value: 'lineNo',
          align: 'left',
          width: '15%',
        },
        {
          text: 'EAN',
          value: 'ean',
          align: 'left',
          width: '15%',
        },
        {
          text: 'Nome',
          value: 'name',
          align: 'left',
          width: '40%',
        },
        {
          text: 'Motivo do erro',
          value: 'reason',
          align: 'left',
          width: '30%',
        },
      ]
    },
  },
  methods: {
    parseReason(reason) {
      switch (reason) {
        case 'BULK_PRODUCT_UPERT_FAILURE_EAN_REPEAT':
          return 'EAN duplicado'
        case 'BULK_PRODUCT_UPERT_FAILURE_FORMAT':
          return 'Informação faltante'
        case 'BULK_PRODUCT_UPSERT_FAILURE_SKU_REPEAT':
          return 'SKU duplicado'
        case 'BULK_PRODUCT_UPSERT_PRODUCT_WITH_SKU_ALREADY_EXISTS':
          return 'SKU repetido'
        default:
          return 'Desconhecido'
      }
    },
    closeDialog() {
      this.$emit('input', false)
    },
    exportCsv() {
      try {
        getCsvFromBucket(this.urlBucket, 'produtos_falha')
      } catch (error) {
        this.$snackbar({ message: 'Erro ao exportar .csv', snackbarColor: 'error' })
      }
    },
  },
}
</script>

<style lang="scss">
.text-alert {
  color: #e03211 !important;
  font-weight: 700 !important;
  text-decoration: underline !important;
}
</style>
